import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { UserService } from 'shared/services/User/user.service';
import { environment } from 'environments/environment';


@Injectable()
export class ReservationService {

    constructor(private http: Http, private us: UserService) {
    }

    create(package_id, seat_count, stripe_token) {
        const headers = new Headers();
        headers.append('token', this.us.user.token);
        const userParams = new FormData();
        userParams.append('stripe_token', stripe_token);
        userParams.append('seat_count', seat_count);
        userParams.append('package_id', package_id);
        return this.http.post(environment.API_BASE_URL + '/reservations/create', userParams, { headers: headers }).map(res => {
            return res.json();
        })
            .catch(err => {
                return Observable.throw(err.json());
            });
    }

    private handleError(error: Response) {
        console.log('Handle error called in inventory service... Printing error...');
        return Observable.throw(error.json() || 'Server Error');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/Reservations/reservations.service.ts